import {CognitoUserPool} from "amazon-cognito-identity-js";

 const poolData = {
     UserPoolId: "us-east-2_0ryoOYFba",
     ClientId: "jd1f39jqdvv3rn6tpl8olk3k6",
     storage: window.localStorage
 }
const cognitoUserPool = new CognitoUserPool(poolData);

export default cognitoUserPool;
